import { Routes, Route } from "react-router-dom/dist";
import Login from "./auth/Login";
import HomePage from "./pages/HomePage";
import PatientsPage from "./pages/PatientsPage";
import LabsPage from "./pages/LabsPage";
import LabTestsPage from "./pages/LabTestsPage";
import LabProgressPage from "./pages/LabProgressPage";
import BMSPublicQRPage from "./pages/BMSPublicQRPage";
import BMSPublicFormPage from "./pages/BMSPublicFormPage";
//import { AuthProvider } from "./auth/auth";
//import RequireAuth from "./components/RequireAuth";
import RequireAuth from "./auth/RequireAuth";
import LoginFormTest from "./auth/LoginFormTest";
import PersistLogin from "./auth/PersistLogin";
import BMSThankYouPage from "./pages/BMSThankYouPage";
import BMSMenuPage from "./pages/BMSMenuPage";
import BlankPage from "./pages/BlankPage";
import QRBlank from "./pages/QRBlank";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />}></Route>
      <Route path="/logintest" element={<LoginFormTest />}></Route>
      <Route path="/blankpage" element={<BlankPage />}></Route>
      <Route path="/qrblank" element={<QRBlank />}></Route>

      <Route element={<PersistLogin />}>
        <Route element={<RequireAuth />}>
          <Route path="home" element={<HomePage />}></Route>
          <Route path="patients" element={<PatientsPage />}></Route>
          <Route path="laboratorios" element={<LabsPage />}></Route>
          <Route path="lab-tests" element={<LabTestsPage />}></Route>
          <Route path="lab-tests-progress" element={<LabProgressPage />}></Route>
        </Route>
      </Route>

      <Route path="qrDisplay" element={<BMSPublicQRPage/>}></Route>
      <Route path="buttons-oncologia" element={<BMSMenuPage/>}></Route>
      <Route path="qrPatientForm" element={<BMSPublicFormPage/>}></Route>
      <Route path="qrThankYou" element={<BMSThankYouPage/>}></Route>

    </Routes>
  );
}

export default App;
 